import { LanguageOption, Integration, Feature } from '../types';

export const LANGUAGES: LanguageOption[] = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी', flag: '🇮🇳' },
  { code: 'mn', name: 'Mongolian', nativeName: 'Монгол хэл', flag: '🇲🇳' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
  { code: 'kk', name: 'Kazakh', nativeName: 'Қазақ тілі', flag: '🇰🇿' },
  { code: 'uz', name: 'Uzbek', nativeName: "O'zbek tili", flag: '🇺🇿' },
  { code: 'ky', name: 'Kyrgyz', nativeName: 'Кыргыз тили', flag: '🇰🇬' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', flag: '🇹🇭' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'ne', name: 'Nepali', nativeName: 'नेपाली', flag: '🇳🇵' },
];

export const INTEGRATIONS: Integration[] = [
  { id: 'website', name: 'Website', icon: 'Globe' },
  { id: 'whatsapp', name: 'WhatsApp', icon: 'MessageCircle' },
  { id: 'facebook', name: 'Facebook', icon: 'MessageCircle' },
  { id: 'email', name: 'Email', icon: 'Mail' },
  { id: 'slack', name: 'Slack', icon: 'MessageCircle' },
  { id: 'telegram', name: 'Telegram', icon: 'MessageCircle' },
  { id: 'api', name: 'API', icon: 'Code' },
  { id: 'more', name: 'More', icon: 'Plus' },
];

export const FEATURES: Feature[] = [
  { icon: 'Globe', titleKey: 'features.multilingual.title', descKey: 'features.multilingual.desc' },
  { icon: 'Zap', titleKey: 'features.instant.title', descKey: 'features.instant.desc' },
  { icon: 'Brain', titleKey: 'features.learning.title', descKey: 'features.learning.desc' },
  { icon: 'Mic', titleKey: 'features.voice.title', descKey: 'features.voice.desc' },
  { icon: 'BarChart3', titleKey: 'features.analytics.title', descKey: 'features.analytics.desc' },
  { icon: 'Shield', titleKey: 'features.security.title', descKey: 'features.security.desc' },
];

export const SUPPORTED_LANGUAGES = [
  'English',
  'Español',
  '中文',
  'हिंदी',
  'العربية',
  'Mongolian',
];
